import { Component, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from 'src/app/services/order.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { getStringDate } from 'src/app/common/util';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';


@Component({
  selector: 'app-purchases-order',
  templateUrl: './purchases-order.component.html',
  styleUrls: ['./purchases-order.component.scss']
})
export class PurchasesOrderComponent {
  showingOrder: { [key: number]: boolean } = {};
  showingCancel: { [key: number]: boolean } = {};
  showingHistory: { [key: number]: boolean } = {};
  showingHistoryDetail: { [key: number]: boolean } = {};
  updated: number = 0;
  filterWord: string = null;
  historyDetailShowed = null;
  orders = [];
  ordersActive = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  createOrder = false;
  orderShowed = null;
  historyShowed = null;
  seeingAll = false;
  userId = null;
  isHistorical: boolean;
  getClimbOrders = false;

  history = 0;
  permissionType = PermissionTypeEnum;
  companyName = "";
  company = null;
  currentCompany = null;

  constructor(
    private orderService: OrderService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private purchaseOrderService: PurchaseOrderService,
    private createService: TemplateInvoice,
  ) {
    this.userId = JSON.parse(authService.getCurrentUser()).id;
    this.company = JSON.parse(authService.getCurrentCompany());
    this.companyName = this.company.companyName;
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5017 && element.read) {
          this.seeingAll = true;
        } else if (element.roleId == 5040 && element.create) {
          this.getClimbOrders = true;
        }
      }
    }
    this.seeingAll = false;
  }

  ngOnInit(): void {
    this.isHistorical = this.route.snapshot.data.isHistorical;
    this.getOrders();
  }

  setOrders() {
    this.orders = this.orders.sort((a, b) => {
      return b.date - a.date
    });
    this.pagination.total = this.orders;
    this.resetPagination();
  }
  
  setOrdersActive() {
    this.orders = this.orders.sort((a, b) => {
      return b.date - a.date
    });
    this.pagination.total = this.ordersActive;
    this.resetPagination();
  }

  getOrders() {
    if (this.isHistorical) {
      if (this.getClimbOrders) {
        this.orderService.getClimbOrders().subscribe({
          next: (response: ResponseObject) => {
            var climbOrders = response.data;
            climbOrders.forEach((c) => {
              c.climb = true;
              this.orders.push(c);
            });
            this.setOrders();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
      } else {
        this.showNormalOrders();
      }
    } else {
      this.showNormalOrders();
    }
  }

  getOrdersActive() {
    // this.orderService.getOrdersActive().subscribe({
    //   next: (response: ResponseObject) => {
    //     this.ordersActive = response.data;
    //     if (!this.seeingAll && !this.isHistorical) {
    //       this.orders = this.orders.filter((u) => {
    //         return u.createdBy.id == this.userId
    //       })
    //     }
    //     this.setOrders();
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastService.error(error.error.message);
    //   }
    // })
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  showNormalOrders() {
    this.orderService.getOrders().subscribe({
      next: (response: ResponseObject) => {
        this.orders = response.data;
        if (!this.seeingAll && !this.isHistorical) {
          this.orders = this.orders.filter((u) => {
            return u.createdBy.id == this.userId
          })
        }
        if (this.getClimbOrders) {
          this.orderService.getClimbOrders().subscribe({
            next: (response: ResponseObject) => {
              var climbOrders = response.data;
              climbOrders.forEach((c) => {
                c.climb = true;
                this.orders.push(c);
              });
              this.setOrders();
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.error(error.error.message);
            }
          })
        } else {
          this.setOrders();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  closeCreateOrder(created) {
    if (created) {
      this.getOrders();
      this.updated = this.updated+1
    }
    this.createOrder = false;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  showOrder(order: any) {
    if (this.showingOrder[order.id]) {
      return;
    }
    this.showingOrder[order.id] = true;
    this.orderService.getOrderDetail(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.orderShowed = {};
        this.orderShowed['items'] = response.data;
        this.orderShowed['items'].forEach(element => {
          element['polishOff'] = 0;
        });
        this.orderShowed['items'].forEach(element => {
          element['provider'] = {
            value: null,
            verified: false,
            required: true,
            message: 'Campo requerido',
            class: 'fa-asterisk',
            color: 'danger',
            data: null,
            filterElements: []
          };
        });
        this.orderShowed['orderId'] = order.id;
        this.orderShowed['order'] = order;
        this.orderShowed['climb'] = order['climb'] ? true : false;
        this.showingOrder[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingOrder[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  confirmChanges() {
    /*   if (this.showingOrder[this.orderShowed['orderId']]) {
         return;
       }
       this.showingOrder[this.orderShowed['orderId']] = true;
       var newPolishOff = new OrderPolishOffRequest();
       newPolishOff.date = (new Date()).getTime();
       newPolishOff.isCancelled = false;
       newPolishOff.orderId = this.orderShowed['orderId'];
       this.orderShowed.forEach(order => {
         newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
       });
       this.orderService.polishOff(newPolishOff).subscribe({
         next: (response: ResponseObject) => {
           this.toastService.success(response.data);
           this.orderShowed = null;
           this.showingOrder[newPolishOff.orderId] = false;
           this.getOrders();
         },
         error: (error: HttpErrorResponse) => {
           this.showingOrder[newPolishOff.orderId] = false;
           this.toastService.error(error.error.message);
         }
       });*/
  }

  historyDetailOrder(order: any) {
    if (this.showingHistoryDetail[order.id]) {
      return;
    }
    this.showingHistoryDetail[order.id] = true;
    this.orderService.orderHistoryDetail(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.historyDetailShowed = response.data;
        this.showingHistoryDetail[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingHistoryDetail[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  historyOrder(order: any) {
    if (this.showingHistory[order.id]) {
      return;
    }
    this.showingHistory[order.id] = true;
    this.orderService.orderHistory(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.historyShowed = response.data;
        this.showingHistory[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingHistory[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  anulateOrder() {
    /*  if (this.showingCancel[this.orderShowed['orderId']]) {
        return;
      }
      this.showingCancel[this.orderShowed['orderId']] = true;
      var newPolishOff = new OrderPolishOffRequest();
      newPolishOff.date = (new Date()).getTime();
      newPolishOff.isCancelled = true;
      newPolishOff.orderId = this.orderShowed['orderId'];
      this.orderShowed.forEach(order => {
        newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
      });
      this.orderService.polishOff(newPolishOff).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success(response.data);
          this.orderShowed = null;
          this.getOrders();
          this.showingCancel[this.orderShowed['orderId']] = false;
        },
        error: (error: HttpErrorResponse) => {
          this.showingCancel[this.orderShowed['orderId']] = false;
          this.toastService.error(error.error.message);
        }
      });*/
  }

  closePolishOff(created: boolean) {
    if (created) {
      this.getOrders();
    }
    this.orderShowed = null;
  }

  resetDeletingDiv() {
    this.orderShowed = null;
    this.historyShowed = null;
  }

  searching() {
    this.pagination.total = this.orders.filter((order) => {
      return order.id + '' == this.filterWord || order.warehouse.name.toLowerCase().includes(this.filterWord.toLowerCase()) || order.createdBy.email.toLowerCase().includes(this.filterWord.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  downloadOrderPdf(order){
    this.getOrderDetail(order);
  }

  updatedOrderUpdate(event){
    if(event) {
      this.updated = this.updated+1
    }
  }

  getOrderDetail(order) {
    let orderId = order.id;
    let orderDetails = [];
    if (!orderId) {
      return;
    }
    this.purchaseOrderService.getOrder(orderId).subscribe({
      next: (response: any) => {
        orderDetails = response.data;

        console.log("Order", order);
        console.log("Detalles", orderDetails);

        const template = this.createReceiptFromData(order,orderDetails) as InvoiceTemplateModel;
        this.createInvoicePDF(template);
      },
      error: (error) => {
        this.toastService.error("Error al obtener los detalles del pedido", "Error");
      }
    });
  }

  createReceiptFromData(orderData, orderDetails): InvoiceTemplateModel {
    let warehouseData = orderDetails[0].warehouseData;
    let providerData = orderData.providerData;
    console.log("warehouseData",warehouseData);
    console.log("providerData",providerData);

    let templateGenerated = new InvoiceTemplateModel();
    templateGenerated.warehouse = warehouseData;
    templateGenerated.type = InvoiceType.PROVIDER;
    templateGenerated.client.name = providerData.name;
    templateGenerated.client.nit = providerData.nit;
    templateGenerated.client.address = providerData.address != null ? providerData.address : "CIUDAD";
    templateGenerated.certifier.signature = '';
    templateGenerated.certifier.date = "";
    templateGenerated.certifier.nit = "";
    templateGenerated.certifier.data = "";
    templateGenerated.invoice.date = (orderData.creationDate) ? new Date(orderData.creationDate).toLocaleDateString('en-CA') : "";
    templateGenerated.invoice.number = (orderData.number) ? orderData.number.toString() : "";
    templateGenerated.invoice.serial = "ORDEN";
    templateGenerated.seller.name = this.companyName;
    templateGenerated.seller.city = "";
    templateGenerated.seller.nit = templateGenerated.warehouse.nit ? templateGenerated.warehouse.nit : (this.company.companyNIT ? this.company.companyNIT : "");
    templateGenerated.seller.state = '';
    templateGenerated.seller.street = "";
    var totalTemp = 0;
    orderDetails.forEach(bd => {
      totalTemp += bd.quantity * bd.cost;
      const tempDetail = new InvoiceItemModel(bd.quantity, bd.cost, bd.productData.name);
      tempDetail.code = bd.productData.code ?? '';
      templateGenerated.items.push(tempDetail);
    });
    templateGenerated.total = totalTemp;
    return templateGenerated;
  }

  async createInvoicePDF(invoiceData: InvoiceTemplateModel) {
    var selected = invoiceData.warehouse as WarehouseResponse;
    var configurationInvoice = new ConfigurationInvoice(selected.nfact, selected.fcolor, selected.scolor, selected.tcolor, selected.slogan);
    console.log("Prueba");
    this.createService.selectTemplate(configurationInvoice, invoiceData, null);
  }

}
